const CLASSES = {
    ACTIVE: '-isPlaying',
};

let player;
let current;

export default function init(el) {
    player = new window.Audio();

    el.addEventListener('click', clickHandler.bind(null, el));
}

function clickHandler(el, event) {
    event.preventDefault();

    if (typeof current === 'undefined') {
        setSource(el);
        play();
    } else if (current === el) {
        if (isPaused()) {
            play();
        } else {
            pause();
        }
    } else {
        pause();
        setSource(el);
        play();
    }
}

function play() {
    current.classList.add(CLASSES.ACTIVE);
    player.play();
}

function pause() {
    current.classList.remove(CLASSES.ACTIVE);
    player.pause();
}

function isPaused() {
    return player.paused;
}

function setSource(el) {
    current = el;
    player.src = el.dataset.url;
}